

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { LocationsSetup } from "../../components/LocationsSetup/LocationsSetup";
import { EarningSummary } from "../../components/EarningSummary";


export const EarningSummaryPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Earning Summary"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<EarningSummary />}
    />
  );
};
